/* eslint-disable react-hooks/exhaustive-deps */
import * as wjrInput from "@grapecity/wijmo.react.input"
import { Container, Row, Col, Card } from "react-bootstrap"
import AlertComponent from "../../../components/AlertComponent"
import { useEffect, useRef, useState } from "react"
import TextInput from "../../../components/InputWrapper/TextInput"
import { useDispatch } from "react-redux"
import { AppDispatch } from "../../.."
import * as wjcInput from "@grapecity/wijmo.input"
import { Button } from "react-bootstrap"
import {
  clearAlert,
  setAlerts,
  setWarningAlerts,
} from "../../../globalStore/alertStore"
import MasterRegisterFormRow from "../../../components/MasterRegisterFormRow"
import { Prompt, useHistory, useParams } from "react-router-dom"
import { TApiResponse } from "../../../service/TApiResponse"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import { showInfoToast } from "../../../components/CustomToast"
import ZimuinSyuroZikanService from "../../../service/driverpayroll/zimuinSyuroZikan/zimuinSyuroZikanService"
import SyainService from "../../../service/master/syain/syainService"
import {
  TZimuinSyuroZikanPostReq,
  TZimuinSyuroZikanPutReq,
} from "../../../service/driverpayroll/zimuinSyuroZikan/TZimuinSyuroZikan"
import { eレコード種別 } from "../../../constant/enum/frontend"
import dayjs from "dayjs"
import { TSyainInfoGetRes } from "../../../service/master/syain/TSyain"
import CONSTANT from "../../../constant"
import {
  画面ロック開始,
  画面ロック解除,
} from "../../../globalStore/progressStore"
import { numberToMillisecond } from "../../../ts/util/decimalUtil"
import Decimal from "decimal.js"

/**
 * 事務員就労時間修正
 * @returns
 */
const ZimuinSyuroZikanRegister = () => {
  const param = useParams<{
    year: string
    month: string
    syainid: string
    id: string
  }>()

  const history = useHistory()

  //#region [state]

  // 固定情報
  const [社員コード, set社員コード] = useState<string>()
  const [社員氏名, set社員氏名] = useState<string>()

  // 実績情報
  const [出勤日数, set出勤日数] = useState<number>()
  const [休出日数, set休出日数] = useState<number>()
  const [特休日数, set特休日数] = useState<number>()
  const [有休日数, set有休日数] = useState<number>()

  const [勤務時間, set勤務時間] = useState<number>()
  const [残業時間, set残業時間] = useState<number>()
  const [深夜時間, set深夜時間] = useState<number>()
  const [休出時間, set休出時間] = useState<number>()

  const [更新日時, set更新日時] = useState<string>()

  // アラート制御
  const disPatch: AppDispatch = useDispatch()

  // modal
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)

  // 戻る確認ダイアログ表示フラグ
  const isPrompt = useRef(false)

  // errorフラグ
  const [hasSearched, setHasSearched] = useState(false)
  const [Form外エラーメッセージList] = useState<string[]>([])

  //#endregion

  //#region [method]

  /**
   * 社員情報取得
   * @param id
   * @param signal
   */
  const getSyain = async (id: number, signal: AbortSignal) => {
    try {
      const service = new SyainService()

      const res = (await service.get(id)) as TApiResponse<TSyainInfoGetRes>

      if (res.data) {
        set社員コード(res.data.社員コード)
        set社員氏名(res.data.社員氏名)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
    }
  }

  /**
   * 給与実績情報取得
   * @param id
   * @param signal
   */
  const getData = async (id: number, signal: AbortSignal) => {
    const service = new ZimuinSyuroZikanService()

    try {
      const res = await service.get(id, signal)
      if (res.data) {
        // state設定
        set出勤日数(res.data.事務員給与_出勤日数)
        set休出日数(res.data.事務員給与_休出日数)
        set特休日数(res.data.事務員給与_特休数)
        set有休日数(res.data.事務員給与_有休数)

        // ミリ秒変換してからセットする
        const ミリ秒 = new Decimal(3600000)
        const d勤務時間 = new Decimal(res.data.事務員給与_出勤時間 ?? 0)
        const d残業時間 = new Decimal(res.data.事務員給与_残業時間 ?? 0)
        const d深夜時間 = new Decimal(res.data.事務員給与_深夜時間 ?? 0)
        const d休出時間 = new Decimal(res.data.事務員給与_休出時間 ?? 0)

        set勤務時間(d勤務時間.div(ミリ秒).toNumber())
        set残業時間(d残業時間.div(ミリ秒).toNumber())
        set深夜時間(d深夜時間.div(ミリ秒).toNumber())
        set休出時間(d休出時間.div(ミリ秒).toNumber())

        set更新日時(res.data.事務員給与_更新日時)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
    }
  }

  /**
   * 更新アイテム生成
   * @returns
   */
  const createPutZimuinSyuroZikan = (): TZimuinSyuroZikanPutReq => {
    // pathから年月を生成
    const dateString = param.year + "-" + param.month + "-01"
    const 年月 = dayjs(dateString).startOf("month").format("YYYY/MM/DD")

    // 整数フォーマットから、実績用にミリ秒変換して返却
    const t勤務時間 = numberToMillisecond(勤務時間 ?? 0)
    const t残業時間 = numberToMillisecond(残業時間 ?? 0)
    const t深夜時間 = numberToMillisecond(深夜時間 ?? 0)
    const t休出時間 = numberToMillisecond(休出時間 ?? 0)

    return {
      給与実績ID: parseInt(param.id) ?? undefined,
      レコード種別: eレコード種別.事務員就労時間一覧,
      給与支給年月: 年月,
      社員ID: parseInt(param.syainid),
      事務員給与_出勤日数: 出勤日数 ?? 0,
      事務員給与_休出日数: 休出日数 ?? 0,
      事務員給与_特休数: 特休日数 ?? 0,
      事務員給与_有休数: 有休日数 ?? 0,
      事務員給与_出勤時間: t勤務時間,
      事務員給与_残業時間: t残業時間,
      事務員給与_深夜時間: t深夜時間,
      事務員給与_休出時間: t休出時間,
      事務員給与_更新日時: 更新日時 ?? undefined,
    }
  }

  /**
   * 登録アイテム生成
   * @returns
   */
  const createPostZimuinSyuroZikan = (): TZimuinSyuroZikanPostReq => {
    // pathから年月を生成
    const dateString = param.year + "-" + param.month + "-01"
    const 年月 = dayjs(dateString).startOf("month").format("YYYY/MM/DD")

    // 整数フォーマットから、実績用にミリ秒変換して返却
    const t勤務時間 = numberToMillisecond(勤務時間 ?? 0)
    const t残業時間 = numberToMillisecond(残業時間 ?? 0)
    const t深夜時間 = numberToMillisecond(深夜時間 ?? 0)
    const t休出時間 = numberToMillisecond(休出時間 ?? 0)

    return {
      レコード種別: eレコード種別.事務員就労時間一覧,
      給与支給年月: 年月,
      社員ID: parseInt(param.syainid),
      事務員給与_出勤日数: 出勤日数 ?? 0,
      事務員給与_休出日数: 休出日数 ?? 0,
      事務員給与_特休数: 特休日数 ?? 0,
      事務員給与_有休数: 有休日数 ?? 0,
      事務員給与_出勤時間: t勤務時間,
      事務員給与_残業時間: t残業時間,
      事務員給与_深夜時間: t深夜時間,
      事務員給与_休出時間: t休出時間,
    }
  }

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = () => {
    //TODO: ここにバリデーションチェックを実装
    if (!isValidationCheck()) return

    setIsConfirmModalShow(true)
  }

  /**
   * 登録時チェック
   * @returns
   */
  const isValidationCheck = () => {
    disPatch(clearAlert())
    Form外エラーメッセージList.splice(0, Form外エラーメッセージList.length)

    let hasError = false
    let messages: Array<string> = []

    const 半日単位 = 0.5

    // 日数の刻みチェック
    if (出勤日数 != null) {
      const 端数 = 出勤日数 % 半日単位
      if (0 < 端数) {
        messages.push(
          `出勤日数は、小数点以下を0.5(半日)単位で入力してください。`
        )
        hasError = true
      }
    }
    if (休出日数 != null) {
      const 端数 = 休出日数 % 半日単位
      if (0 < 端数) {
        messages.push(
          `休出日数は、小数点以下を0.5(半日)単位で入力してください。`
        )
        hasError = true
      }
    }
    if (特休日数 != null) {
      const 端数 = 特休日数 % 半日単位
      if (0 < 端数) {
        messages.push(
          `特休日数は、小数点以下を0.5(半日)単位で入力してください。`
        )
        hasError = true
      }
    }
    if (有休日数 != null) {
      const 端数 = 有休日数 % 半日単位
      if (0 < 端数) {
        messages.push(
          `有休日数は、小数点以下を0.5(半日)単位で入力してください。`
        )
        hasError = true
      }
    }

    if (hasError) {
      Form外エラーメッセージList.push(...messages)
      setHasSearched(hasError)
    }

    return !hasError
  }

  /**
   * 送信
   */
  const submit = async () => {
    try {
      if (
        出勤日数 == null ||
        休出日数 == null ||
        特休日数 == null ||
        有休日数 == null ||
        勤務時間 == null ||
        残業時間 == null ||
        深夜時間 == null ||
        休出時間 == null
      )
        // バリデーション完了後のため数値は正常だが エラー回避のためここでも確認
        return

      const service = new ZimuinSyuroZikanService()
      let res: TApiResponse<boolean>

      // 給与実績IDの有無で処理分岐
      if (param.id) {
        res = await service.put(createPutZimuinSyuroZikan(), param.id)
      } else {
        res = await service.post(createPostZimuinSyuroZikan())
      }

      if (res) {
        isPrompt.current = false
        history.goBack()
        showInfoToast(`給与実績の${param.id ? "更新" : "登録"}が完了しました`)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  //#endregion

  //#region [effect]

  //初期設定
  useEffect(() => {
    //画面全体ロック
    disPatch(画面ロック開始())

    const abortController = new AbortController()

    //   社員情報を先に取得
    getSyain(parseInt(param.syainid), abortController.signal)

    //   給与実績データはIDの有無で処理分岐
    if (param.id) {
      getData(parseInt(param.id), abortController.signal).finally(() => {
        // ファイルロード後、戻るボタン押下時に警告が出るように変更
        isPrompt.current = true
      })
    } else {
      set出勤日数(0)
      set休出日数(0)
      set特休日数(0)
      set有休日数(0)

      set勤務時間(0)
      set残業時間(0)
      set深夜時間(0)
      set休出時間(0)

      set更新日時("")
      // ファイルロード後、戻るボタン押下時に警告が出るように変更
      isPrompt.current = true
    }

    disPatch(画面ロック解除())
    return () => {
      abortController.abort()
    }
  }, [])

  // error監視
  useEffect(() => {
    if (hasSearched && [...Form外エラーメッセージList].find((e) => e !== "")) {
      disPatch(setWarningAlerts([...Form外エラーメッセージList]))
    }
    setHasSearched(false)
  }, [hasSearched])

  //#endregion

  return (
    <>
      <Prompt
        when={isPrompt.current}
        message={CONSTANT.MESSAGES.BROWSER_BACK}></Prompt>
      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">事務員就労時間修正</span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 登録条件カード */}
            <Card className="w-50rem">
              <Card.Body>
                <Container fluid className="register-form">
                  {/* 社員コード */}
                  <MasterRegisterFormRow label="社員コード" isRequired={false}>
                    <div className="w-4rem">
                      <TextInput
                        id="社員コード"
                        name="社員コード"
                        value={社員コード}
                        setValue={(v) => {}}
                        isReadOnly
                      />
                    </div>
                    <div className="w-8rem">
                      <TextInput
                        id="社員氏名"
                        name="社員氏名"
                        value={社員氏名}
                        setValue={(v) => {}}
                        isReadOnly
                      />
                    </div>
                  </MasterRegisterFormRow>

                  <br></br>

                  {/* 出勤日数 */}
                  <MasterRegisterFormRow
                    label="出勤日数"
                    isRequired={false}
                    remarks={<div>半日は0.5で記入</div>}>
                    <wjrInput.InputNumber
                      initialized={(control: wjcInput.InputNumber) => {
                        control.inputElement?.focus()
                      }}
                      style={{ width: "5rem" }}
                      id="出勤日数"
                      name="出勤日数"
                      format={"N1"}
                      focus
                      isRequired={true}
                      value={出勤日数}
                      valueChanged={(c: wjcInput.InputNumber, e: any) => {
                        c.value != null
                          ? set出勤日数(c.value)
                          : set出勤日数(undefined)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 休出日数 */}
                  <MasterRegisterFormRow
                    label="休出日数"
                    isRequired={false}
                    remarks={<div>半日は0.5で記入</div>}>
                    <wjrInput.InputNumber
                      style={{ width: "5rem" }}
                      id="休出日数"
                      name="休出日数"
                      format={"N1"}
                      isRequired={true}
                      value={休出日数}
                      valueChanged={(c: wjcInput.InputNumber, e: any) => {
                        c.value != null
                          ? set休出日数(c.value)
                          : set休出日数(undefined)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 特休日数 */}
                  <MasterRegisterFormRow
                    label="特休日数"
                    isRequired={false}
                    remarks={<div>半日は0.5で記入</div>}>
                    <wjrInput.InputNumber
                      style={{ width: "5rem" }}
                      id="特休日数"
                      name="特休日数"
                      format={"N1"}
                      isRequired={true}
                      value={特休日数}
                      valueChanged={(c: wjcInput.InputNumber, e: any) => {
                        c.value != null
                          ? set特休日数(c.value)
                          : set特休日数(undefined)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 有休日数 */}
                  <MasterRegisterFormRow
                    label="有休日数"
                    isRequired={false}
                    remarks={<div>半日は0.5で記入</div>}>
                    <wjrInput.InputNumber
                      style={{ width: "5rem" }}
                      id="有休日数"
                      name="有休日数"
                      format={"N1"}
                      isRequired={true}
                      value={有休日数}
                      valueChanged={(c: wjcInput.InputNumber, e: any) => {
                        c.value != null
                          ? set有休日数(c.value)
                          : set有休日数(undefined)
                      }}
                    />
                  </MasterRegisterFormRow>

                  <br></br>

                  {/* 勤務時間 */}
                  <MasterRegisterFormRow label="勤務時間" isRequired={false}>
                    <wjrInput.InputNumber
                      style={{ width: "5rem" }}
                      id="勤務時間"
                      name="勤務時間"
                      format={"N0"}
                      isRequired={true}
                      value={勤務時間}
                      valueChanged={(c: wjcInput.InputNumber, e: any) => {
                        c.value != null
                          ? set勤務時間(c.value)
                          : set勤務時間(undefined)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 残業時間 */}
                  <MasterRegisterFormRow label="残業時間" isRequired={false}>
                    <wjrInput.InputNumber
                      style={{ width: "5rem" }}
                      id="残業時間"
                      name="残業時間"
                      format={"N0"}
                      isRequired={true}
                      value={残業時間}
                      valueChanged={(c: wjcInput.InputNumber, e: any) => {
                        c.value != null
                          ? set残業時間(c.value)
                          : set残業時間(undefined)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 深夜時間 */}
                  <MasterRegisterFormRow label="深夜時間" isRequired={false}>
                    <wjrInput.InputNumber
                      style={{ width: "5rem" }}
                      id="深夜時間"
                      name="深夜時間"
                      format={"N0"}
                      isRequired={true}
                      value={深夜時間}
                      valueChanged={(c: wjcInput.InputNumber, e: any) => {
                        c.value != null
                          ? set深夜時間(c.value)
                          : set深夜時間(undefined)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 休出時間 */}
                  <MasterRegisterFormRow label="休出時間" isRequired={false}>
                    <wjrInput.InputNumber
                      style={{ width: "5rem" }}
                      id="休出時間"
                      name="休出時間"
                      format={"N0"}
                      isRequired={true}
                      value={休出時間}
                      valueChanged={(c: wjcInput.InputNumber, e: any) => {
                        c.value != null
                          ? set休出時間(c.value)
                          : set休出時間(undefined)
                      }}
                    />
                  </MasterRegisterFormRow>
                </Container>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row className="search-button">
          <Col xl={{ span: "auto", offset: 0 }}>
            <Button
              type="submit"
              variant="waiting"
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                beforeSubmit()
              }}>
              {param.id ? `更新` : `登録`}
            </Button>
          </Col>
          <Col>
            <Button
              type="button"
              variant="secondary"
              onClick={() => history.goBack()}>
              一覧に戻る
            </Button>
          </Col>
        </Row>
      </Container>

      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で{param.id ? "更新" : "登録"}しますか？
      </ConfirmModal>
    </>
  )
}

export default ZimuinSyuroZikanRegister
